import React from 'react';

const SafetySection = () => {
  const safetyFeatures = [
    {
      icon: 'location_searching',
      title: 'GPS-Tracked Vehicles',
      description: 'Live trip visibility for admin dashboards. Monitor every ride in real-time with route deviation alerts.'
    },
    {
      icon: 'verified',
      title: 'Police-Verified Drivers',
      description: '100% background screening before onboarding. Annual re-verification and ongoing safety training for all drivers.'
    },
    {
      icon: 'female',
      title: "Women's Safety",
      description: 'SOS panic button in every vehicle. Live tracking shareable with family. Dedicated helpline for after-hours drops.'
    },
    {
      icon: 'health_and_safety',
      title: 'Insurance Coverage',
      description: 'All rides covered under comprehensive insurance. Passenger protection and personal accident coverage included.'
    },
    {
      icon: 'gavel',
      title: 'Regulatory Compliance',
      description: 'Full compliance with Motor Vehicle Act and local transport regulations. Commercial permits for all vehicles.'
    },
    {
      icon: 'emergency',
      title: 'Instant SOS Alerts',
      description: 'Emergency alerts sent to driver, admin, and operations team simultaneously. Rapid response protocol within 60 seconds.'
    }
  ];

  return (
    <section className="py-[60px] bg-surface-container-lowest" id="safety">
      <div className="max-w-[1400px] mx-auto px-[32px]">
        <div className="text-center mb-[48px]">
          <span className="text-primary font-bold text-[14px] uppercase tracking-[0.2em] mb-[16px] block">Safety & Compliance Excellence</span>
          <h2 className="font-headline text-[36px] font-extrabold tracking-tight text-on-surface">Compliance Standards for Safe Employee Transportation</h2>
          <div className="w-[80px] h-[6px] bg-primary mx-auto mt-[24px]"></div>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-[24px]">
          {safetyFeatures.map((feature, index) => {
            const isEven = index % 2 === 0;
            const hoverColor = isEven ? 'group-hover:bg-primary' : 'group-hover:bg-orange-500';
            const hoverTextColor = isEven ? 'group-hover:text-primary' : 'group-hover:text-orange-500';
            const accentBar = isEven ? 'bg-gradient-to-r from-primary to-primary/60' : 'bg-gradient-to-r from-orange-500 to-orange-500/60';
            
            return (
              <div 
                key={index} 
                className="group relative bg-white rounded-[16px] border border-outline-variant/20 overflow-hidden hover:shadow-xl hover:border-primary/30 transition-all duration-300"
              >
                {/* Top accent bar */}
                <div className={`h-[4px] ${accentBar}`}></div>
                
                <div className="p-[28px]">
                  {/* Icon */}
                  <div className={`w-[48px] h-[48px] rounded-[12px] ${isEven ? 'bg-primary/10' : 'bg-orange-500/10'} flex items-center justify-center mb-[20px] ${hoverColor} group-hover:scale-105 transition-all duration-300`}>
                    <span className={`material-symbols-outlined ${isEven ? 'text-primary' : 'text-orange-500'} text-[24px] group-hover:text-white transition-colors duration-300`}>{feature.icon}</span>
                  </div>
                  
                  {/* Content */}
                  <h4 className={`font-bold text-[18px] text-on-surface mb-[12px] ${hoverTextColor} transition-colors`}>
                    {feature.title}
                  </h4>
                  <p className="text-on-surface-variant text-[14px] leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Stats bar */}
        <div className="mt-[48px] grid grid-cols-2 md:grid-cols-4 gap-[24px]">
          <div className="text-center p-[24px] bg-white rounded-[12px] border border-outline-variant/10">
            <p className="font-headline text-[32px] font-extrabold text-primary">100%</p>
            <p className="text-[14px] text-on-surface-variant mt-[4px]">Compliance Rate</p>
          </div>
          <div className="text-center p-[24px] bg-white rounded-[12px] border border-outline-variant/10">
            <p className="font-headline text-[32px] font-extrabold text-orange-500">24/7</p>
            <p className="text-[14px] text-on-surface-variant mt-[4px]">Emergency Support</p>
          </div>
          <div className="text-center p-[24px] bg-white rounded-[12px] border border-outline-variant/10">
            <p className="font-headline text-[32px] font-extrabold text-primary">500+</p>
            <p className="text-[14px] text-on-surface-variant mt-[4px]">Verified Drivers</p>
          </div>
          <div className="text-center p-[24px] bg-white rounded-[12px] border border-outline-variant/10">
            <p className="font-headline text-[32px] font-extrabold text-orange-500">60s</p>
            <p className="text-[14px] text-on-surface-variant mt-[4px]">Response Time</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafetySection;


